import { defineStore } from 'pinia';

import { UserDto } from './user.interface';
import userService from './user.service';

export const useUserStore = defineStore({
  id: 'globalStore',
  state: (): {
    user: UserDto | undefined;
  } => ({
    user: undefined,
  }),
  getters: {
    userId(): string | undefined {
      return this.user?.id;
    },
  },
  actions: {
    async load(): Promise<void> {
      this.user = await userService.getUser();
    },
  },
});
